module.exports = __webpack_public_path__ + "9c1cdc68e666171a8145633d43b2bc4c.svg";